import React, {Component} from 'react'
import styled from '@emotion/styled'
import sv from '../../../../styles/styles'
import {ChevronLeft, ChevronRight} from "react-feather";
import {__isAvailable} from "../../../../_helpers/commons/utility.helper";
import {withTranslation} from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import {faPlay, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const MAX_HIT_WIDTH = 400;  // maximum search-query-hit width

// STYLE ##########################################################

const Baseline = styled('div')`
  height: 12px;
  margin-bottom: -12px;
  width: 100%;  /* this is important for Search.calcLeftSpacing to work */
  order: 2;
  ${sv.flexRow}
  align-items: flex-end;
  ${props => props.center ? "justify-content: center" : ''};
  z-index: 1200;
`;

const Shade = styled('div')`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  box-shadow: 0 -2px 3px rgba(0,0,0,0.3);
  z-index: 1201;
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 1202;
  position: absolute;
  left: ${props => props.leftSpacing ? (props.leftSpacing + "px") : ''};
  color: rgba(255,255,255,.5);
`;

const Content = styled(`div`)`
  ${sv.flexRow}
  background: rgba(83,83,83,.9);
  max-width: ${MAX_HIT_WIDTH}px;
  border-radius: 4px;
  order: 1;
`;

const Result = styled(`div`)`
  background: #454545;
  padding: 10px;
  margin: 5px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  line-height: 1.2;
  span {
    font-weight: 700;
    color: ${sv.colors.light} !important;
    padding: 2px;
  }
`;

const PlayButton = styled(`div`)`
  display: inline-flex;
  width: 18px;
  height: 15px;
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
`;

const NoResultText = styled(`div`)`
  margin-bottom: 5px;
`;

const QueryText = styled(`span`)`
`;

const ResultTopContainer = styled(`div`)`
  ${sv.flexRow}
  justify-content: flex-end;
  padding-bottom: 5px;
  font-size: 12px;
`;

const ResultSmallIndicators = styled(`div`)`
  background: #454545;
  padding: 5px 10px;
  border-radius: 5px;
  margin-left: 5px;
`;

const ResultCounter = styled(ResultSmallIndicators)`
`;

const CloseButton = styled(ResultSmallIndicators)`
  color: rgba(255,255,255,.75);
  cursor: pointer;
  &:hover {
    background: rgba(150,150,150,.75);
  } 
  height: 22px;
  width: 22px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

const ButtonContainer = styled(`div`)`
  min-height: inherit;
  ${sv.flexCenter};
`;

const ChapterButton = styled(`div`)`
  color: rgba(255,255,255,.75);
  transition: background .2s ease-out;
  cursor: pointer;
  min-height: inherit;
  width: 100%;
  ${sv.flexCenter};
  border-radius: 6px;
  &:hover {
    background: rgba(150,150,150,.75);
  }
`;

// COMPONENT ##########################################################

class Search extends Component {

  constructor(props) {
    super(props);
    this.closeSearch = this.closeSearch.bind(this);
    this.hideSearch = this.hideSearch.bind(this);

    this.state = {
      buffer: 50,
    };
  }


  shouldComponentUpdate(prevProps, prevState, snapshot) {
    const isSearchResultNew = prevProps.results !== this.props.results;
    const isNewHitNavigation = prevProps.currentHit !== this.props.currentHit;
    const isParentContainerUpdated = prevProps.parentContainerW !== this.props.parentContainerW;
    const isErrorStateNew = prevProps.isTranscriptError !== this.props.isTranscriptError;

    return isSearchResultNew || isNewHitNavigation || isParentContainerUpdated || isErrorStateNew;
  }

  navToPreviousHit(totalHits) {
    (this.props.currentHit - 1 < 1)
      ? this.props.setCurrentHit(totalHits)
      : this.props.setCurrentHit(this.props.currentHit-1);
  }

  navToNextHit(totalHits) {
    (this.props.currentHit + 1 > totalHits)
        ? this.props.setCurrentHit(1)
        : this.props.setCurrentHit(this.props.currentHit+1);
  }

  handlePlay(hit) {
    this.props.resumeFromTime(hit.time);
  }

  calcLeftSpacing = (hit) => {
    const parentPadding = 5;
    let parentContainerW = (this.container)
                                ? this.container.getBoundingClientRect().width  // use hit-parent container if available
                                : this.props.parentContainerW;                  // use search-parent container as fallback
    parentContainerW -= 2*parentPadding; //padding

    const hitContainerW = (this.hitBox)
                            ? this.hitBox.getBoundingClientRect().width   // use hit container if available
                            : MAX_HIT_WIDTH;                              // use max allowed hit width

    const hitPositionInContainer = (hit.position/100) * parentContainerW + parentPadding;
    const halfOfHitContainerW = hitContainerW/2;

    const isLeftOverflow = (hitPosition, halfHitSize) => halfHitSize > hitPosition;
    const isRightOverflow = (hitPosition, halfHitSize, parentWidth) => halfHitSize > (parentWidth - hitPosition);

    let leftSpacing;
    if( isLeftOverflow(hitPositionInContainer, halfOfHitContainerW )) {                           // case : left-overflow
      leftSpacing = 0;  // start from far-left
    } else if( isRightOverflow(hitPositionInContainer, halfOfHitContainerW, parentContainerW) ) { // case : right-overflow
      const doesHitFitInContainer = (parentContainerW - hitContainerW) > 0;
      leftSpacing = (doesHitFitInContainer)
                      ? parentContainerW - hitContainerW  // arrange left spacing so that hit is placed at the far-right
                      : 0;                                // hit is too big for parent so start from far-left
    } else {                                                                                      // case : no-overflow
      leftSpacing = hitPositionInContainer - halfOfHitContainerW; // place in the middle of the position
    }
    leftSpacing += parentPadding;
    return leftSpacing;
  };

  closeSearch = () => this.props.toggleSearch();      // clears current search

  hideSearch = () => this.props.toggleSearch(false);  // does not clear current search

  // RENDER ###################################################################

  render() {
    const {t, results, isTranscriptError} = this.props;

    const query = __isAvailable(results) ? results.query : '';
    const hits = __isAvailable(results) ? results.hits : [];

    const totalHits = hits.length;
    const isHitsAvailable = totalHits > 0;
    const isNavNecessary = totalHits > 1;
    const currentHit = (this.props.currentHit > totalHits) ? 1 : this.props.currentHit;
    const currentIndex = currentHit - 1;

    const closeButton = <CloseButton onClick={this.closeSearch}><FontAwesomeIcon icon={faTimes}/></CloseButton>;

    return (
      <Baseline
        className = "search-baseline"
        ref={node => this.container = node}
        center={!isHitsAvailable}
      >
        {this.props.gistShown &&
          <Shade onClick={this.hideSearch}/>
        }

        {/* Transcript Data issues */}
        {isTranscriptError &&
          <Container>
            <Content center maxWidth={MAX_HIT_WIDTH}>
              <Result>
                <NoResultText>
                  {t('Search could not be performed at the moment. Please contact support.')}
                </NoResultText>
              </Result>
            </Content>
            <ResultTopContainer>{closeButton}</ResultTopContainer>
          </Container>
        }

        {!isTranscriptError &&
        <>

          {/* Search Result Hit is not available */}
          {!isHitsAvailable && query !== "" &&
              <Container
                  ref={node => this.hitBox = node}
                  leftSpacing={this.calcLeftSpacing(10)}>
                <Content>
                  <Result>
                    <NoResultText><QueryText>`{query}`</QueryText> {t('not found.')}</NoResultText>
                  </Result>
                </Content>
                <ResultTopContainer>{closeButton}</ResultTopContainer>
              </Container>
          }

          {/* Search Result Hit is available */}
          {isHitsAvailable &&
              <Container
                  ref={node => this.hitBox = node}
                  leftSpacing={this.calcLeftSpacing(hits[currentIndex])}>
                <Content>
                  {isNavNecessary &&
                  <ButtonContainer onClick={() => this.navToPreviousHit(totalHits)}>
                    <ChapterButton>
                      <ChevronLeft buffer={this.state.buffer} size={35}/>
                    </ChapterButton>
                  </ButtonContainer>
                  }

                  <Result>
                    <PlayButton onClick={() => this.handlePlay(hits[currentIndex])}>
                      <FontAwesomeIcon icon={faPlay} size="xs" />
                    </PlayButton>
                    {ReactHtmlParser(hits[currentIndex].context)}
                  </Result>

                  {isNavNecessary &&
                  <ButtonContainer next onClick={() => this.navToNextHit(totalHits)}>
                    <ChapterButton next>
                      <ChevronRight buffer={this.state.buffer} size={35}/>
                    </ChapterButton>
                  </ButtonContainer>
                  }
                </Content>
                <ResultTopContainer>
                  <ResultCounter>{currentHit} of {totalHits}</ResultCounter>
                  {closeButton}
                </ResultTopContainer>
              </Container>
          }
        </>
        }
      </Baseline>
    )
  }
}

const translatedSearch = withTranslation()(Search);
export default translatedSearch;
